const APROBADO = 'APROBADO';
const PENDIENTE = 'PENDIENTE';
const PUBLICADO = 'PUBLICADO';
const NO_APROBADO = 'NO_APROBADO';
const NO_PUBLICADO = 'NO_PUBLICADO';
const PAGADO = 'PAGADO';
const NO_PAGADO = 'NO_PAGADO';
const ESTADOS = [
  APROBADO,
  PENDIENTE,
  PUBLICADO,
  NO_APROBADO,
  NO_PUBLICADO,
  NO_PAGADO,
  PAGADO,
];

export default {
  APROBADO,
  PENDIENTE,
  PUBLICADO,
  NO_APROBADO,
  NO_PUBLICADO,
  NO_PAGADO,
  PAGADO,
  labelValue: () => ESTADOS.map((estado) => ({ label: estado, value: estado })),
  enableActions: (estado) => estado !== NO_APROBADO
    && estado !== NO_PUBLICADO,
};
